if (!customElements.get('crftop-footer-accordion')) {
  customElements.define('crftop-footer-accordion', class extends HTMLElement {
    connectedCallback() {
      this.media = matchMedia('(max-width: 749px)');
      this.applyLayout = () => {
        this.querySelectorAll('details').forEach(group => {
          const focused = document.activeElement;
          const summary = group.querySelector('summary');
          if (this.media.matches && group.contains(focused) && focused !== summary) {
            summary.focus();
          }
          group.open = !this.media.matches;
          if (!this.media.matches && focused === summary) group.querySelector('a')?.focus();
        });
      };
      this.selectBlock = event => {
        const group = event.target.closest('details');
        if (group && this.contains(group)) group.open = true;
      };
      this.media.addEventListener('change', this.applyLayout);
      this.addEventListener('shopify:block:select', this.selectBlock);
      this.applyLayout();
    }

    disconnectedCallback() {
      this.media?.removeEventListener('change', this.applyLayout);
      this.removeEventListener('shopify:block:select', this.selectBlock);
    }
  });
}
